import React from "react";
import './styles.css';

function Notice() {
  return (
    <div className="notice">
      {/* &copy; {new Date().getFullYear()} iamjayandhan. All rights reserved. */}
      "Keep it clean and share responsibly – no room for undesirables here!"
    </div>
  );
}

export default Notice;
